import { fetchDataAPI } from '../helpers/fetchDataAPI';
import { fileUpload } from '../helpers/fileUpload';
import { URL_BASE_API } from './glogal';
import { store } from '../store'


export const getProfile = () => {
    const url = `${URL_BASE_API}/api/profile/getprofile`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const getUserProfileToView = (userId) => {
    const url = `${URL_BASE_API}/api/profile/getprofile`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const saveProfile = (name, company, country, phone, urlTiktok, urlYoutube, urlInstagram, urlFacebook, urlSpotify, urlApple, biography) => {
    const url = `${URL_BASE_API}/api/profile/save`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: name,
            field03: company,
            field04: country,
            field05: phone,
            field06: urlTiktok,
            field07: urlYoutube,
            field08: urlInstagram,
            field09: urlFacebook,
            field10: urlSpotify,
            field11: urlApple,
            field12: biography,
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const uploadProfilePhoto = (file) => {
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const url = `${URL_BASE_API}/api/profile/changeprofileimage/${userId}`;
    const data = new FormData();
    data.append('asset', file);

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fileUpload(url, data, config);

    return rsp;
}



export const setStars = (evaluatedUserId, cntStars) => {
    const url = `${URL_BASE_API}/api/profile/setstars`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: evaluatedUserId,
            field03: cntStars,
            lang: language
        }, 
        config
    );
    
    return rsp;
}
